module.exports = __webpack_public_path__ + "static/media/mask_example2.4ae813e5.png";